// hooks/usePWAJumpIframe.ts
import { ref, onMounted } from 'vue'
import { isInPWA, isInIframe, isInAndroidApp } from '@/env' // 确保路径正确
import { useUserInfo } from '@/store'
export function usePWAJumpIframe() {
  const iframeUrl = ref<any>(null)
  const isPWA = ref<boolean>(false)
  const shouldShowIframe = ref<boolean>(false)
  async function checkPWAAndPreventionJump() {
    isPWA.value = isInPWA

    if (!isPWA.value && !isInAndroidApp) {
      return
    }

    const currentUrl = new URL(window.location.href)
    const params = new URLSearchParams(currentUrl.search)
    const newUrlParams = Array.from(params.entries())
      .filter(
        ([key]) =>
          key !== 'preventionJump' && key !== 'currentDomain' && key !== 'tid',
      )
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    if (currentUrl.searchParams.get('preventionJump') !== 'true') {
      console.log('preventionJump 参数不是 true')
      return
    }

    const currentDomain = currentUrl.searchParams.get('currentDomain')

    // 获取iframe跳转的域名  如果没有就使用链接上的域名
    const iframeJumpDomain: any = JSON.parse(
      localStorage.getItem('iframeJumpDomain') as string,
    ) || [currentDomain]
    const getRandomElement = (array: string[]) => {
      return array[Math.floor(Math.random() * array.length)]
    }
    const jumpDomain = getRandomElement(iframeJumpDomain)

    // console.log('检测是否在 pwa 应用打开的项目``22222222```````', jumpDomain)
    const newUrl = `https://${jumpDomain}/home?${newUrlParams}`
    if (newUrl) {
      iframeUrl.value = newUrl
      shouldShowIframe.value = true

      //   console.log(
      //     '检测是否在 pwa 应用打开的项目``33333333333```````',
      //     iframeUrl.value,
      //   )

      //   console.log(
      //     '检测是否在 pwa 应用打开的项目``33333333333```````',
      //     shouldShowIframe.value,
      //   )
    }

    const postData = async (url = '') => {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*', // 注意跨域问题，可能需要调整
            'Content-Type': 'application/json',
          },
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return await response.json()
      } catch (error) {
        console.error('Error during fetch:', error)
        return null
      }
    }

    const result = await postData(
      `https://${currentDomain}/api/carbon-misc/public/domain/list?type=MainDomain`,
    )

    if (result.data && Array.isArray(result.data) && result.data.length > 0) {
      const randomDomain = result.data
      localStorage.setItem('iframeJumpDomain', JSON.stringify(randomDomain))
    }
  }

  onMounted(checkPWAAndPreventionJump)

  return {
    isPWA,
    iframeUrl,
    shouldShowIframe,
  }
}

export function PWALoginIframe() {
  if (isInIframe) {
    //  接收iframe的登录状态
    // console.log('接收iframe的登录状态')
    window.addEventListener('message', (event) => {
      //   console.log('接收iframe的登录状态2222222', event.data)
      //   console.log('接收iframe的登录状态2222222', event.data.payload)
      if (event.data.type === 'INIT_AUTH') {
        const userInfo = JSON.parse(event.data.payload.userInfo) || {}
        if (userInfo) {
          useUserInfo().login(userInfo, userInfo.token)

          console.log('我是在iframe环境下被调用的login')
        }
      }
    })
  } else {
    // 监听主PWA的登录状态
    window.addEventListener('message', (event) => {
      const { type, payload } = event.data
      //   console.log('给项目添加监听登录登出事件111111')
      //   console.log('给项目添加监听登录登出事件111111', type, payload)
      if (type === 'LOGIN') {
        localStorage.setItem('authToken', payload.userInfo)
      }
      if (type === 'LOGOUT') {
        localStorage.removeItem('authToken')
      }
    })
  }
}

//apk防封进入后注册登录状态
window.setAPKLoginSession = (userInfo: any) => {
  const binaryString = urlsafeBase64Decode(userInfo)
  if (binaryString) {
    const decodedUserInfo = JSON.parse(utf8Decode(binaryString) as string)
    useUserInfo().login(decodedUserInfo, decodedUserInfo.token)
  }
}

function urlsafeBase64Decode(encodedString) {
  // 将 URL 安全的字符替换回标准 Base64 的字符
  const base64String = encodedString.replace(/-/g, '+').replace(/_/g, '/')
  try {
    return atob(base64String)
  } catch (e) {
    console.error('Base64 decode error:', e)
    return null
  }
}

function utf8Decode(binaryString) {
  try {
    // 使用 TextDecoder 将二进制字符串解码为 UTF-8 字符串
    return new TextDecoder('utf-8').decode(
      new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0))),
    )
  } catch (e) {
    console.error('UTF-8 decode error:', e)
    return null
  }
}

// 给iframe发送登录状态
export function sendAuthToIframe() {
  const iframe: any = document.getElementById('gameIframe')
  // console.log("给iframe发送登录状态的 (模板)1111111");
  if (iframe && iframe.contentWindow) {
    // console.log("给iframe发送登录状态的 (模板)22222222");
    setTimeout(() => {
      iframe.contentWindow.postMessage(
        {
          type: 'INIT_AUTH',
          payload: {
            userInfo: localStorage.getItem('authToken'),
          },
        },
        '*',
      )
    }, 1000)
  } else {
    console.warn('iframe 或 contentWindow 不存在')
  }
}
